import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './nav/AppDimensions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { bodyBold2czwdzwknab0k as bodyBold } from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Addresscpovxna1tjmg as Address } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_line11xah9qv5pazjt as get_line1,
  get_line21zlifp7q9r4u8 as get_line2,
  get_city16w5sptiuu653 as get_city,
  get_state2h1ip52e42bk8 as get_state,
  get_zipcodeh4z27ky940y0 as get_zipcode,
} from '../../../../../crowpay-shared/com/crowpay/AddressFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlankNamed365y7czhf0np3 as assertNotBlankNamed } from '../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  validates376qnagkfv6he as validates,
  issueText2dqtp9rg036jt as issueText,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { nullToBlank2cwx9yazfqg5v as nullToBlank } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { get_entriesyts36b0as1vz as get_entries } from '../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function addressForm(_this__u8e3s4, address, widthLimit, allowEdit, forceValid, validateWhen) {
  widthLimit = widthLimit === VOID ? get_AppDimensions().ig2_1 : widthLimit;
  allowEdit = allowEdit === VOID ? null : allowEdit;
  forceValid = forceValid === VOID ? null : forceValid;
  var tmp;
  if (validateWhen === VOID) {
    tmp = addressForm$lambda;
  } else {
    tmp = validateWhen;
  }
  validateWhen = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(widthLimit)));
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_0 = get_expanding(view_0);
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  view_1.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  view_2.bb9(get_AppDimensions().rg2_1);
  view_2.lbb(get_centered(view_2), bodyBold(view_2, 'Line 1'));
  view_2.lbb(colored(view_2, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_2, '*'));
  view_1.hbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_1 = view_1.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_line1(it);
  var tmp$ret$8 = lensPath(address, tmp$ret$7);
  var line1 = assertNotBlankNamed(tmp$ret$8, 'Address line 1', 'Address line 1 cannot be blank');
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextInput())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  if (allowEdit == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it_0 = allowEdit;
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextInput$_get_enabled_$ref_3dkh3c(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, TextInput$_set_enabled_$ref_xnynf8(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$10 = it_0($this$reactiveScope);
      this_0.set(tmp$ret$10);
      return Unit_instance;
    });
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_3.vb5_1.bb4_1.kb7_1.placeholder = 'Line 1';
  view_3.zah(view_3.icn_1, line1);
  validates(view_3, [line1], validateWhen);
  view_1.hbb(p_3, view_3);
  var tmp$ret$19 = issueText(view_1, get_issues(line1), VOID, validateWhen);
  view_1.lbb(tmp_1, tmp$ret$19);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  var tmp_5 = get_expanding(view_0);
  // Inline function 'com.crowpay.views.components.field2' call
  var label = 'Line 2 (Optional)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_4, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_6 = view_4.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextInput())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  if (allowEdit == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it_1 = allowEdit;
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextInput$_get_enabled_$ref_3dkh3c_0(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, TextInput$_set_enabled_$ref_xnynf8_0(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$27 = it_1($this$reactiveScope);
      this_1.set(tmp$ret$27);
      return Unit_instance;
    });
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_5.vb5_1.bb4_1.kb7_1.placeholder = 'Line 2';
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_9 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$33 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$33);
  var tmp$ret$35 = get_line2(it_2);
  var tmp$ret$36 = lensPath(address, tmp$ret$35);
  view_5.zah(view_5.icn_1, nullToBlank(tmp$ret$36));
  view_4.hbb(p_5, view_5);
  view_4.lbb(tmp_6, view_5);
  view_4.lbb(view_4.jbb(SubtextSemantic_getInstance()), errorText(view_4));
  view_0.hbb(p_4, view_4);
  view_0.lbb(tmp_5, view_4);
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(widthLimit)));
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  var tmp_10 = get_expanding(view_6);
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  view_7.zbm(true);
  view_7.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  view_8.zbm(false);
  view_8.bb9(get_AppDimensions().rg2_1);
  view_8.lbb(get_centered(view_8), bodyBold(view_8, 'City'));
  view_8.lbb(colored(view_8, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_8, '*'));
  view_7.hbb(p_8, view_8);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_11 = view_7.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_12 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$54 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$54);
  var tmp$ret$56 = get_city(it_3);
  var tmp$ret$57 = lensPath(address, tmp$ret$56);
  var city = assertNotBlankNamed(tmp$ret$57, 'Address city', 'Address city cannot be blank');
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextInput())(view_7.pc());
  var tmp0_elvis_lhs_9 = view_7.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
  view_7.gbb(p_9, view_9);
  if (allowEdit == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it_4 = allowEdit;
    var tmp_13 = KMutableProperty0();
    var tmp_14 = TextInput$_get_enabled_$ref_3dkh3c_1(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('enabled', 0, tmp_13, tmp_14, TextInput$_set_enabled_$ref_xnynf8_1(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$59 = it_4($this$reactiveScope);
      this_2.set(tmp$ret$59);
      return Unit_instance;
    });
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_9.vb5_1.bb4_1.kb7_1.placeholder = 'City';
  view_9.zah(view_9.icn_1, city);
  validates(view_9, [city], validateWhen);
  view_7.hbb(p_9, view_9);
  var tmp$ret$68 = issueText(view_7, get_issues(city), VOID, validateWhen);
  view_7.lbb(tmp_11, tmp$ret$68);
  view_6.hbb(p_7, view_7);
  view_6.lbb(tmp_10, view_7);
  var tmp_15 = get_expanding(view_6);
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_10 = view_6.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
  view_6.gbb(p_10, view_10);
  view_10.zbm(true);
  view_10.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.zbm(false);
  view_11.bb9(get_AppDimensions().rg2_1);
  view_11.lbb(get_centered(view_11), bodyBold(view_11, 'State'));
  view_11.lbb(colored(view_11, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_11, '*'));
  view_10.hbb(p_11, view_11);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_16 = view_10.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_17 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$79 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
  var it_5 = new (DataClassPathSelf())(tmp$ret$79);
  var tmp$ret$81 = get_state(it_5);
  var state = lensPath(address, tmp$ret$81);
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (Select())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.gbb(p_12, view_12);
  if (allowEdit == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it_6 = allowEdit;
    var tmp_18 = KMutableProperty0();
    var tmp_19 = Select$_get_enabled_$ref_eg5v13(view_12);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('enabled', 0, tmp_18, tmp_19, Select$_set_enabled_$ref_fu8bat(view_12));
    reactiveScope(view_12, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$84 = it_6($this$reactiveScope);
      this_3.set(tmp$ret$84);
      return Unit_instance;
    });
  }
  var tmp_20 = _Constant___init__impl__v45mub(get_entries());
  view_12.ocf(state, new (Constant())(tmp_20), addressForm$lambda_0);
  view_10.hbb(p_12, view_12);
  view_10.lbb(tmp_16, view_12);
  view_6.hbb(p_10, view_10);
  view_6.lbb(tmp_15, view_10);
  var tmp_21 = get_expanding(view_6);
  // Inline function 'com.crowpay.views.components.requiredField' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_13 = view_6.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_6 : tmp0_elvis_lhs_13;
  view_6.gbb(p_13, view_13);
  view_13.zbm(true);
  view_13.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_14.zbm(false);
  view_14.bb9(get_AppDimensions().rg2_1);
  view_14.lbb(get_centered(view_14), bodyBold(view_14, 'Zipcode'));
  view_14.lbb(colored(view_14, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_14, '*'));
  view_13.hbb(p_14, view_14);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_22 = view_13.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_23 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$102 = isInterface(tmp_23, KSerializer()) ? tmp_23 : THROW_CCE();
  var it_7 = new (DataClassPathSelf())(tmp$ret$102);
  var tmp$ret$104 = get_zipcode(it_7);
  var tmp$ret$105 = lensPath(address, tmp$ret$104);
  var zip = assertNotBlankNamed(tmp$ret$105, 'Address zipcode', 'Address zipcode cannot be blank');
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (TextInput())(view_13.pc());
  var tmp0_elvis_lhs_15 = view_13.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
  view_13.gbb(p_15, view_15);
  if (allowEdit == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it_8 = allowEdit;
    var tmp_24 = KMutableProperty0();
    var tmp_25 = TextInput$_get_enabled_$ref_3dkh3c_2(view_15);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('enabled', 0, tmp_24, tmp_25, TextInput$_set_enabled_$ref_xnynf8_2(view_15));
    reactiveScope(view_15, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$107 = it_8($this$reactiveScope);
      this_4.set(tmp$ret$107);
      return Unit_instance;
    });
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_15.vb5_1.bb4_1.kb7_1.placeholder = 'Zipcode';
  view_15.zah(view_15.icn_1, zip);
  validates(view_15, [zip], validateWhen);
  view_13.hbb(p_15, view_15);
  var tmp$ret$116 = issueText(view_13, get_issues(zip), VOID, validateWhen);
  view_13.lbb(tmp_22, tmp$ret$116);
  view_6.hbb(p_13, view_13);
  view_6.lbb(tmp_21, view_13);
  view.hbb(p_6, view_6);
  if (!(forceValid == null)) {
    reactive(view, ($this$reactive) => {
      var tmp;
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      if (forceValid($this$reactive)) {
        address.xat().sat();
        tmp = Unit_instance;
      } else {
        address.xat().wat();
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
function addressForm$lambda(_this__u8e3s4) {
  return true;
}
function TextInput$_get_enabled_$ref_3dkh3c(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextInput$_get_enabled_$ref_3dkh3c_0(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8_0(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextInput$_get_enabled_$ref_3dkh3c_1(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8_1(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function Select$_get_enabled_$ref_eg5v13(p0) {
  return () => p0.fbs();
}
function Select$_set_enabled_$ref_fu8bat(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function addressForm$lambda_0(it) {
  return it.g9b_1;
}
function TextInput$_get_enabled_$ref_3dkh3c_2(p0) {
  return () => p0.fbs();
}
function TextInput$_set_enabled_$ref_xnynf8_2(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  addressForm as addressForm32k03uh8crpev,
};
//endregion

//# sourceMappingURL=addressForm.mjs.map
